import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

import { queueTaskInBackground } from "utils/queueTaskInBackground";

type Props = {
  /** The "filled" progress, relative to `max` */
  value: number;
  /** The "max" progress (defaults to `100`) */
  max?: number;
  progressClassName?: string;
};

/** Atomic progress bar component */
const ProgressBar = ({ value, max = 100, progressClassName }: Props) => {
  const [valueToAnimate, setValueToAnimate] = useState(0);

  useEffect(() => {
    queueTaskInBackground(() =>
      setValueToAnimate(value !== 0 ? Math.min((value / max) * 100, 100) : 10)
    );
  }, [value, max]);

  return (
    <div className="h-2 w-full rounded-full bg-gray-200">
      <div
        className={twMerge(
          "h-full rounded-full bg-brand-color transition-[width] duration-1000",
          progressClassName
        )}
        style={{
          width: `${valueToAnimate}%`,
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
